import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BancoService } from 'src/app/services/banco.service';
import { CuentaBancariaService } from 'src/app/services/cuenta-bancaria.service';
import { PagoService } from 'src/app/services/pago.service';
import * as _ from 'lodash';
import { DatesService } from 'src/app/shared/services/dates.service';
import { DocumentoService } from 'src/app/services/documento.service';

@Component({
  selector: 'app-pagos-cliente-formas-pago-tabs',
  templateUrl: './formas-pago-tabs.component.html',
  styleUrls: ['./formas-pago-tabs.component.scss'],
  providers: [SecurityService],
})
export class FormasPagoTabsComponent implements OnInit, OnChanges {
  @Output() onFormaPagoAgregada: EventEmitter<any> = new EventEmitter<any>();
  @Input() bloqueado: boolean = false;

  // Form
  formCheque: FormGroup;
  formTransferencia: FormGroup;
  formEfectivo: FormGroup;
  formDeposito: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private incomingData: any;
  private clienteData: any;
  optionsBancosEmpresa: Array<any> = [];
  optionsBancosTodos: Array<any> = [];
  optionsCuentasBancosTransferencia: Array<any> = [];
  optionsCuentasBancosDeposito: Array<any> = [];
  enabled: boolean = false;
  formasDePagoAgregadas: any = null;
  fechaVencimientoDoc: Date;
  acMontoMedioPago: number = 0;
  // Utils
  private log: any;
  montoPago: string = '';
  public submittedmedioPago: boolean = false;
  dataCliente: any;
  tienePagoCuenta: boolean = false;
  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private bancoService: BancoService,
    private cuentaBancariaService: CuentaBancariaService,
    private pagoService: PagoService,
    private datesService: DatesService,
    private documentoService: DocumentoService
  ) {
    this.log = this.clog.log('REALIZAR-PAGOS-TABS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.getBancosEmpresas();
    this.getBancosTodos();

    this.createForms();

    this.formChangesSubscriptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Asegura que el bloqueo se aplique aunque `loadData()` se ejecute antes
    if (changes && changes['bloqueado']) {
      this.setEnabled(!this.bloqueado);
    }
  }

  private setEnabled(value: boolean) {
    this.enabled = value;

    // Deshabilitar/habilitar controles para bloquear realmente la edición
    if (this.formCheque) value ? this.formCheque.enable({ emitEvent: false }) : this.formCheque.disable({ emitEvent: false });
    if (this.formTransferencia) value ? this.formTransferencia.enable({ emitEvent: false }) : this.formTransferencia.disable({ emitEvent: false });
    if (this.formEfectivo) value ? this.formEfectivo.enable({ emitEvent: false }) : this.formEfectivo.disable({ emitEvent: false });
    if (this.formDeposito) value ? this.formDeposito.enable({ emitEvent: false }) : this.formDeposito.disable({ emitEvent: false });
  }

  public loadData(data, cliente) {
    if (!data) return;
    this.montoPago = (data.monto_coforme != null ? data.monto_coforme : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    this.incomingData = data;
    this.clienteData = cliente;

    const difs: any[] = data && data.difereciaPago && Array.isArray(data.difereciaPago) ? data.difereciaPago : [];
    const saldoDocumento: any[] = data && Array.isArray(data.saldoDocumento) ? data.saldoDocumento : [];
    const tieneDocs = saldoDocumento.length > 0;
    const diferencialCero = Number(data && data.monto_coforme != null ? data.monto_coforme : 0) === 0;

    // Verificar si hay pago a cuenta seleccionado/utilizado
    this.tienePagoCuenta = difs.some((pago: any) => Number(pago && pago.tipo_pago_cuenta_codigo != null ? pago.tipo_pago_cuenta_codigo : 0) === 1);
    const tienePagoCuentaSeleccionado = difs.some((pago: any) => {
      const utilizado = Number(
        pago && pago.pago_cuenta_utilizado != null
          ? pago.pago_cuenta_utilizado
          : 0
      );
      return utilizado > 0;
    });

    // Si el diferencial queda en 0 por pago a cuenta (y hay facturas seleccionadas), bloquear ingreso de medios de pago
    const debeBloquear = this.bloqueado || (tieneDocs && diferencialCero && tienePagoCuentaSeleccionado);
    this.setEnabled(!debeBloquear);

    this.obtenerFechaVencimiento(data.saldoDocumento);
    // this.setDefaultDates();
  }

  obtenerFechaVencimiento(saldoDocumento) {
    this.dataCliente = saldoDocumento[0];

    for (let i = 1; i < saldoDocumento.length; i++) {
      if (saldoDocumento[i].fechaEmisionDoc > this.dataCliente.fechaEmisionDoc) {
        this.dataCliente = saldoDocumento[i];
      }
    }
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut: this.clienteData.rut,
      direccion_codigo: this.clienteData.codigo_direccion,
      condicion_pago_codigo: 0,
      fecha_documento: this.dataCliente.fecha_emision,
    };
    //funcion para obtener Fecha Vencimiento 2
    this.documentoService.ObtenerFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.fechaVencimientoDoc = respuesta.fecha_vencimiento;
      this.setFechaPago(this.fechaVencimientoDoc);
    });
  }

  setFechaPago(fechaPago) {
    const now = this.datesService.CurrentDateToShortTimeString();
    // this.formCheque.get('fecha').setValue(fechaPago); -- Fecha de la condicion de Pago

    this.formCheque.get('fecha').setValue(fechaPago);
    this.formTransferencia.get('fecha').setValue(now);
    this.formDeposito.get('fecha').setValue(now);
  }

  setDefaultDates(setCurrentDates: boolean = false) {
    const now = this.datesService.CurrentDateToShortTimeString();
    this.formTransferencia.get('fecha').setValue(now);
    this.formDeposito.get('fecha').setValue(now);

    if (!setCurrentDates) this.formCheque.get('fecha').setValue(now);
    else this.formCheque.get('fecha').setValue(this.fechaVencimientoDoc);
  }

  setLoadSaldo(saldoRecibido) {
    this.setDefaultDates();
    this.montoPago = saldoRecibido.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  private getBancosEmpresas() {
    this.bancoService.obtenerBancoEmpresas(this.rutEmpresa, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBancosEmpresa = registros.map((banco) => ({ value: banco.codigo, label: banco.nombre, ...banco }));
    });
  }

  private getBancosTodos() {
    this.bancoService.obtenerSegunFiltro('', true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBancosTodos = registros.map((banco) => ({ value: banco.codigo, label: banco.nombre, ...banco }));
    });
  }

  private createForms() {
    this.formCheque = this.fb.group({
      nroDocumento: [0, [Validators.required, Validators.min(1)]],
      monto: [0, [Validators.required, Validators.min(1)]],
      fecha: [null, [Validators.required]],
      banco: [null, [Validators.required]],
      nroCuenta: ['', [Validators.required, Validators.minLength(1)]],
    });

    this.formTransferencia = this.fb.group({
      // nroDocumento: [0, [Validators.required, Validators.min(1)]],
      monto: [0, [Validators.required, Validators.min(1)]],
      banco: [null, [Validators.required]],
      nroCuenta: [null, [Validators.required]],
      fecha: [null, [Validators.required]],
    });

    this.formEfectivo = this.fb.group({
      monto: [0, [Validators.required, Validators.min(1)]],
    });

    this.formDeposito = this.fb.group({
      nroDocumento: [0, [Validators.required, Validators.min(1)]],
      monto: [0, [Validators.required, Validators.min(1)]],
      fecha: [null, [Validators.required]],
      banco: [null, [Validators.required]],
      nroCuenta: [null, [Validators.required]],
    });
  }

  formChangesSubscriptions() {
    this.formTransferencia.get('banco').valueChanges.subscribe((banco_codigo) => {
      this.getCuentasTransferencia(banco_codigo);
    });

    this.formDeposito.get('banco').valueChanges.subscribe((banco_codigo) => {
      this.getCuentasDeposito(banco_codigo);
    });
  }

  getCuentasTransferencia(banco_codigo) {
    this.cuentaBancariaService.obtenerCuentaEmpresa(this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.formTransferencia.get('nroCuenta').setValue(null);
      this.optionsCuentasBancosTransferencia = registros.map((cuenta) => ({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta, ...cuenta }));
    });
  }

  getCuentasDeposito(banco_codigo) {
    this.cuentaBancariaService.obtenerCuentaEmpresa(this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.formDeposito.get('nroCuenta').setValue(null);
      this.formDeposito.get('nroCuenta').markAsPristine();
      this.formDeposito.get('nroCuenta').markAsUntouched();
      this.optionsCuentasBancosDeposito = registros.map((cuenta) => ({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta, ...cuenta }));
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  agregarFormaPagoCheque() {
    this.validateAllFormFields(this.formCheque);
    this.submittedmedioPago = true;

    if (!this.formCheque.valid) return;

    const nueva_forma_pago = {
      tipo_pago_codigo: 1, // 1	Cheque
      tipo_cuenta_bancaria_codigo: 0,
      banco_codigo: Number(this.formCheque.get('banco').value),
      numero_cuenta: this.formCheque.get('nroCuenta').value,
      monto: Number(this.formCheque.get('monto').value.toString().replace(/\./g, '')),
      numero_doc: this.formCheque.get('nroDocumento').value,
      fecha_pago: this.formCheque.get('fecha').value,
    };
    this.agregarFormaPago(nueva_forma_pago);
  }

  agregarFormaPagoTransferencia() {
    this.validateAllFormFields(this.formTransferencia);
    this.submittedmedioPago = true;
    if (!this.formTransferencia.valid) return;

    const numero_cuenta = this.formTransferencia.get('nroCuenta').value;
    const tipo_cuenta_bancaria_codigo = this.optionsCuentasBancosTransferencia.filter((cta) => cta.numero_cuenta === numero_cuenta)[0].tipo_cuenta_bancaria_codigo;
    const nueva_forma_pago = {
      tipo_pago_codigo: 2, // 2	Transferencia
      tipo_cuenta_bancaria_codigo,
      banco_codigo: Number(this.formTransferencia.get('banco').value),
      numero_cuenta,
      monto: Number(this.formTransferencia.get('monto').value.toString().replace(/\./g, '')),
      numero_doc: 0,
      fecha_pago: this.formTransferencia.get('fecha').value,
    };

    this.agregarFormaPago(nueva_forma_pago);
  }

  agregarFormaPagoEfectivo() {
    this.validateAllFormFields(this.formEfectivo);
    this.submittedmedioPago = true;

    if (!this.formEfectivo.valid) return;

    const nueva_forma_pago = {
      tipo_pago_codigo: 3, // 3	Efectivo
      tipo_cuenta_bancaria_codigo: 0,
      banco_codigo: 0,
      numero_cuenta: '',
      monto: Number(this.formEfectivo.get('monto').value.toString().replace(/\./g, '')),
      numero_doc: 0,
    };
    this.agregarFormaPago(nueva_forma_pago);
  }

  agregarFormaPagoDeposito() {
    this.validateAllFormFields(this.formDeposito);
    this.submittedmedioPago = true;
    if (!this.formDeposito.valid) return;

    const numero_cuenta = this.formDeposito.get('nroCuenta').value;
    const tipo_cuenta_bancaria_codigo = this.optionsCuentasBancosDeposito.filter((cta) => cta.numero_cuenta === numero_cuenta)[0].tipo_cuenta_bancaria_codigo;
    const nueva_forma_pago = {
      tipo_pago_codigo: 4, // 4	Depósito
      tipo_cuenta_bancaria_codigo,
      banco_codigo: Number(this.formDeposito.get('banco').value),
      numero_cuenta,
      monto: Number(this.formDeposito.get('monto').value.toString().replace(/\./g, '')),
      numero_doc: this.formDeposito.get('nroDocumento').value,
      fecha_pago: this.formDeposito.get('fecha').value,
    };
    this.agregarFormaPago(nueva_forma_pago);
  }

  agregarFormaPago(nueva_forma_pago): boolean {
    if (!this.enabled) {
      this.toastrService.error('Deshabilitado');
      return false;
    }

    // Calcular la suma total de los montos de las formas de pago
    const formas_pago = this.formasDePagoAgregadas ? _.cloneDeep(this.formasDePagoAgregadas.forma_pago) : [];
    formas_pago.forEach((forma_pago) => {
      delete forma_pago.__typename;
      delete forma_pago.checked;
      delete forma_pago.index;
    });

    const sumaMontos = formas_pago.reduce((total, forma) => total + forma.monto, 0);
    const montoNuevo = Number(nueva_forma_pago.monto.toString().replace(/\./g, ''));
    const pagoCuentaUtilizado = this.incomingData.difereciaPago.some((pago: any) => pago.pago_cuenta_utilizado === pago.saldo);


    // Validar que la suma total no supere el monto_conforme
    if (this.tienePagoCuenta && !pagoCuentaUtilizado && sumaMontos + montoNuevo > this.incomingData.monto_coforme) {
      this.toastrService.error('No se puede agregar un monto mayor al saldo a pagar');
      return false;
    }

    nueva_forma_pago.empresa_rut = this.rutEmpresa;
    nueva_forma_pago.sucursal_codigo = this.sucursalEmpresa;
    nueva_forma_pago.cliente_proveedor_rut = this.incomingData.saldoDocumento[0].cliente_proveedor_rut;
    // nueva_forma_pago.fecha_pago = "2021-02-09T14:42:26.79549Z"

    // let tipo_pago_codigo = 1
    // 1	Cheque
    // 2	Transferencia
    // 3	Efectivo
    // 4	Depósito


    const inputParams: any = {
      entidad: {
        forma_pago: formas_pago,
        monto_coforme: this.incomingData.monto_coforme, // diferencial a pagar
      },
    };
    inputParams.entidad = { ...nueva_forma_pago, ...inputParams.entidad };

    // FIX numero_doc
    if (!inputParams.entidad.numero_doc) inputParams.entidad.numero_doc = 0;

    this.log('inputParams', JSON.stringify(inputParams));
    this.pagoService.agregarFormaPago(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return false;
      }

      this.toastrService.success('Operación realizada');
      delete respuesta.__typename;
      respuesta.forma_pago.forEach((forma_pago) => {
        delete forma_pago.__typename;
      });
      this.formasDePagoAgregadas = respuesta;
      this.onFormaPagoAgregada.emit(this.formasDePagoAgregadas);
      this.submittedmedioPago = false;
      this.clearForms(true);
      // this.enabled = false
      return true;
    });
  }

  clearFormCheque() {
    // this.formCheque.reset()
    this.formCheque.markAsUntouched();
    this.formCheque.markAsPristine();

    this.formCheque.get('nroDocumento').setValue(null);
    this.formCheque.get('fecha').setValue(null);
    this.formCheque.get('banco').setValue(null);
    this.formCheque.get('nroCuenta').setValue(null);
  }

  clearFormTransferencia() {
    // this.formTransferencia.reset()
    this.formTransferencia.markAsUntouched();
    this.formTransferencia.markAsPristine();

    this.formTransferencia.get('fecha').setValue(null);
    this.formTransferencia.get('banco').setValue(null);
    this.formTransferencia.get('nroCuenta').setValue(null);
  }

  clearFormEfectivo() {
    // this.formEfectivo.reset()
    this.formEfectivo.markAsUntouched();
    this.formEfectivo.markAsPristine();
  }

  clearFormDeposito() {
    // this.formDeposito.reset();
    this.formDeposito.markAsUntouched();
    this.formDeposito.markAsPristine();

    this.formDeposito.get('nroDocumento').setValue(null);
    this.formDeposito.get('fecha').setValue(null);
    this.formDeposito.get('banco').setValue(null);
    this.formDeposito.get('nroCuenta').setValue(null);
  }

  clearData() {
    this.setEnabled(false);
    this.formasDePagoAgregadas = null;
    this.tienePagoCuenta = false;
    this.clearForms();
  }

  clearForms(setCurrentDates: boolean = false) {
    this.clearFormCheque();
    this.clearFormTransferencia();
    this.clearFormEfectivo();
    this.clearFormDeposito();

    if (setCurrentDates) this.setDefaultDates(setCurrentDates);
  }
}
